import PubSub from "underpub-js";

var VideoCard = function (options) {

	this.options = {
		$el: false
	};

	$.extend(true, this.options, options);

};

VideoCard.prototype.init = function () {

	var self = this;

	this.options.$el.on("click", function(){
		PubSub.publish("VideoModal.show", {videoUrl: self.options.$el.data("video-url")});
	});

};

export default VideoCard;
